__webpack_require__.p = "/redactorfont/onboarding/";